import React from 'react';

import { DocSection } from './DocSection';
import { FullWarningEvent } from '../../restapi/types';
import { toggleValue } from './utils';


interface Props {
	events: FullWarningEvent[];
	selected: number[];
	onSelectionChange: (selected: number[]) => void;
}

export function DocPreview({events, selected, onSelectionChange}: Props) {
	return <div className="doc-preview">
		{events.map(e =>
			<DocSection
				key={e.id}
				event={e}
				selected={selected.includes(e.id)}
				onToggleSelection={() => onSelectionChange(toggleValue(selected, e.id))}
			/>
		)}
	</div>;
}
